var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-block block-banner"},[_c('div',{staticClass:"banner-wrap"},[_c('a',{staticClass:"link",attrs:{"href":"/2023_luck"},on:{"click":function($event){_vm.link('year-luck')}}},[_c('img',{attrs:{"src":"/static/img/recommend/lp/banner/yearluck2023.png","alt":"占うならこちらから","width":"320"}})])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e2c2b6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/counselor/somarimone/blocks/BlockBannerYearLuck.vue
// module id = null
// module chunks = 